(function() {
  'use strict';
  angular.module('common').factory('teledentServiceUnavailableHandler', function() {
    /*
    if is array, returns {data: array, serviceUnavialble: undefined | true}
    else return data augmented with serviceUnavialble.

    If data is null, returns null unless service is unavailable then returns
    {serviceUnavailable: true}
    */
    return _.curry(function(isArray, data, headers) {
      var res, parsed;
      if (data) {
        parsed = angular.fromJson(data);
      }
      if (isArray) {
        res = {};
        res.data = parsed;
      } else {
        res = parsed;
      }
      if ( headers('x-service-unavailable') === 'true') {
        res = res || {};
        res.serviceUnavailable = true;
      }
      return res;
    }, 2);
  });
})();